(function () {
  'use strict';

  var root = document.querySelector('[data-second-desktop-build]');
  if (!root) return;

  var purchaseRoot = root.querySelector('[data-second-desktop-purchase]');
  if (!purchaseRoot) return;

  var decreaseButton = purchaseRoot.querySelector('[data-quantity-decrease]');
  var increaseButton = purchaseRoot.querySelector('[data-quantity-increase]');
  var quantityOutput = purchaseRoot.querySelector('[data-quantity-value]');

  var quantity = 1;

  function renderQuantity() {
    if (!quantityOutput) return;
    quantityOutput.textContent = String(quantity);
  }

  decreaseButton?.addEventListener('click', function () {
    if (quantity <= 1) return;
    quantity -= 1;
    renderQuantity();
  });

  increaseButton?.addEventListener('click', function () {
    quantity += 1;
    renderQuantity();
  });
})();
